export default __webpack_public_path__ + "static/media/8.26f1f59b.png";